import React, { useEffect, useState } from 'react'
import "./pendingActionsCard"
import lifeTimeBookingsPNG from '../../assets/images/bookings_png.png'  
import pendingPayIcon from '../../assets/images/pending_pay_png.png' 
import inTransitPay from '../../assets/images/In-Transit_png.png'  
import completedBkIcon from '../../assets/images/CompletedIcon.png'  
import ApiAgTable from '../ag-table/api_ag-table'
import { useGlobalState } from '../../GlobalState'
import ChartApi from '../../charts/chart.api'


export default function BookingDataCard({chartSelectedEntity , setOpenPendingPay , setpendingPayData}) {
      let { menuList, changeCurrentMenu } = useGlobalState()

  const [countData , setCountData] = useState({})
  const [results, setResults] = useState({})
  const [pendingPay, setpendingPay] = useState({})


  const chartEntities = chartSelectedEntity ?? []

  // useEffect(()=> {
  //    ApiAgTable.dashBdBookingsData().then(res => {
  //               res.clone().json().then((response) => {
  //                 setCountData(response.count)
  //               }, err => {
  //                   console.log(err)
  //               })
  //           })
  // },[])
  const summarize = (Data) => {
    let data = Data?.data
    let val = {
        'SUBMITTED': 0,
        'INPROGRESS': 0,
        'ARCHIVED': 0,
        onTime: -1
    }
    let totalEstTransit = 0
    let totalTransitDeviation = 0
    if(data && data.length>0){
        data.map(e => {
            val[e.status] += 1
            if (e.estTransit) totalEstTransit += e.estTransit
            if (e.transitDeviation) totalTransitDeviation += e.transitDeviation
        })
    }
    if (totalEstTransit) {
        val.onTime = 1 - (totalTransitDeviation / totalEstTransit)
        val.onTime = Math.round(val.onTime)
    }
    setResults(val)
    setpendingPay(Data?.pendingPay)
    setpendingPayData(Data?.pendingPay)
}
      useEffect(() => {
          ChartApi.getAllBookingsForChart(summarize, chartEntities)
      }, [chartEntities])

  const changeMenuFn = () => {
    let menus = menuList.filter(x => x.name == 'Cross-Border')       
    changeCurrentMenu(menus[0].children[4].key)
  }

  const setOpenPendingPayfn = () => {
        setOpenPendingPay(true)
  } 
  return (
    <div className='ml-2' style={{ backgroundColor : "white" , padding : "1% 2%" , borderRadius : "5px" , width: "40%" , cursor : 'pointer' }} >
     <h4 className='is-size-5 wd_100' >Bookings</h4> 
        <div className='is-flex' style={{ gap : '0.5%' }}>
            <div className='leftimeBookingCon ml-1' style={{  color : "#3a5aac" , borderRadius : "5px" , Width : "200px", padding : "0.5%" , textAlign : "center" , borderLeft : "3px solid #193B8A"  , boxShadow: "3px 3px 10px #635f5f" }} onClick={()=>changeMenuFn()}>
          <div className='is-flex mt-2 pl-1 is-align-items-center'>
            <span style={ {padding : '1% 2%' ,width : "30%" , backgroundColor : "#EAF0FF" , borderRadius: '5px'}}>
            <img
              height="15%" width="100%"
              src={lifeTimeBookingsPNG}
              // src\assets\images\bookings_png.png
              alt='vfnvf'
            />
            </span>
            <p className='is-size-7 pl-1'>Lifetime<br/> Bookings</p>
          </div>
             <p className='is-size-6'>{results['SUBMITTED']}</p> 
           </div>
           <div className='ml-1' style={{  color : "#176BBA" , borderRadius : "5px" , Width : "200px", padding : "0.5%" , textAlign : "center" ,  borderLeft : "3px solid #006CA2" , boxShadow: "3px 3px 10px #635f5f"}} onClick={()=>changeMenuFn()}>
           <div className='is-flex mt-2 pl-1 is-align-items-center'>
            <span style={ {padding : '3% 6%' ,width : "30%" , backgroundColor : "#C4E1FC" , borderRadius: '5px'}}>
            <img
              height="15%" width="100%"
              src={inTransitPay}
              alt='vfnvf'
            />
            </span>
            <p className='is-size-7 pl-1'>Shipments<br/> in-transit</p>
          </div>    
             <p className='is-size-6'>{results['INPROGRESS']}</p> 
           </div> 
           <div className='ml-1' style={{ color : "#E87A1A", borderRadius : "5px" , Width : "200px", padding : "0.5%" , textAlign : "center" ,  borderLeft : "3px solid #E87A1A" , boxShadow: "3px 3px 10px #635f5f"}}
           onClick={()=>setOpenPendingPayfn()}>
           <div className='is-flex mt-2 pl-1 is-align-items-center'>
            <span style={ {padding : '3% 6%' ,width : "30%" , backgroundColor : "#FFEBD9" , borderRadius: '5px'}}>
            <img
              height="15%" width="100%"
              src={pendingPayIcon}
              alt='vfnvf'
            />
            </span>
            <p className='is-size-7 pl-1'>Pending<br/> Pay</p>
          </div>   
             <p className='is-size-6'>{pendingPay?.length}</p> 
           </div> 
           <div className='ml-1' style={{ color : "#209133", borderRadius : "5px" , Width : "200px", padding : "0.5%" , textAlign : "center" ,  borderLeft : "3px solid #209133" , boxShadow: "3px 3px 10px #635f5f"}} onClick={()=>changeMenuFn()}>
           <div className='is-flex mt-2 pl-1 is-align-items-center'>
            <span style={ {padding : '3% 6%' ,width : "30%" , backgroundColor : "#DAFFE0" , borderRadius: '5px'}}>
            <img
              height="15%" width="100%"
              src={completedBkIcon}
              alt='vfnvf'
            />
            </span>
            <p className='is-size-7 pl-1'>Completed</p>
          </div>    
             <p className='is-size-6'>{results['ARCHIVED']}</p> 
           </div> 
            </div>  
    </div>
  )
}


